import React from 'react';
import ParticipantStrip from './ParticipantStrip';
import MainParticipant from './MainParticipant';

export default function Room(props) {
    return (
        <div className="room-container">
            <ParticipantStrip />
            <MainParticipant appointmentDetails={props.appointmentDetails} />
        </div>
    );
}
